var exports = {
  "iE": "xaee3c4fa--969c5c--wrapper",
  "wx": "xaee3c4fa--969c5c--header",
  "Kk": "xaee3c4fa--969c5c--icon",
  "zA": "xaee3c4fa--969c5c--_shown",
  "DD": "xaee3c4fa--969c5c--title",
  "o5": "xaee3c4fa--969c5c--content-wrapper",
  "Qs": "xaee3c4fa--969c5c--content",
};

module.exports = exports;
